import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Basic from './Basic';
import LightbulbTwoToneIcon from '@mui/icons-material/LightbulbTwoTone';
import useTheme from '@mui/material/styles/useTheme';
export default (function (_a) {
    var children = _a.children;
    var theme = useTheme();
    return _jsx(Basic, { color: theme.palette.success.main, icon: _jsx(LightbulbTwoToneIcon, { color: "success" }), title: "Tip", children: children });
});
